<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>Forever Christmas</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct" id="toc-0">CONTENTS</p>
<p class="cct" id="toc-1"><a href="#/chapter1#p0007-01-0">PROLOGUE</a></p>
<p class="cct" id="toc-2"><a href="#/chapter2#p0009-01-0">CHAPTER ONE</a></p>
<p class="cct" id="toc-3"><a href="#/chapter3#p0015-01-0">CHAPTER TWO</a></p>
<p class="cct" id="toc-4"><span href="#/chapter4#p0023-01-0" title="Link target outside of Sample">CHAPTER THREE</span></p>
<p class="cct" id="toc-5"><span href="#/chapter5#p0035-01-0" title="Link target outside of Sample">CHAPTER FOUR</span></p>
<p class="cct" id="toc-6"><span href="#/chapter6#p0043-01-0" title="Link target outside of Sample">CHAPTER FIVE</span></p>
<p class="cct" id="toc-7"><span href="#/chapter7#p0047-01-0" title="Link target outside of Sample">CHAPTER SIX</span></p>
<p class="cct" id="toc-8"><span href="#/chapter8#p0053-01-0" title="Link target outside of Sample">CHAPTER SEVEN</span></p>
<p class="cct" id="toc-9"><span href="#/chapter9#p0057-01-0" title="Link target outside of Sample">CHAPTER EIGHT</span></p>
<p class="cct" id="toc-10"><span href="#/chapter10#p0067-01-0" title="Link target outside of Sample">CHAPTER NINE</span></p>
<p class="cct" id="toc-11"><span href="#/chapter11#p0073-01-0" title="Link target outside of Sample">CHAPTER TEN</span></p>
<p class="cct" id="toc-12"><span href="#/chapter12#p0079-01-0" title="Link target outside of Sample">CHAPTER ELEVEN</span></p>
<p class="cct" id="toc-13"><span href="#/chapter13#p0095-01-0" title="Link target outside of Sample">CHAPTER TWELVE</span></p>
<p class="cct" id="toc-14"><span href="#/chapter14#p0103-01-0" title="Link target outside of Sample">CHAPTER THIRTEEN</span></p>
<p class="cct" id="toc-15"><span href="#/chapter15#p0115-01-0" title="Link target outside of Sample">CHAPTER FOURTEEN</span></p>
<p class="cct" id="toc-16"><span href="#/chapter16#p0129-01-0" title="Link target outside of Sample">CHAPTER FIFTEEN</span></p>
<p class="cct" id="toc-17"><span href="#/chapter17#p0143-01-0" title="Link target outside of Sample">CHAPTER SIXTEEN</span></p>
<p class="cct" id="toc-18"><span href="#/chapter18#p0149-01-0" title="Link target outside of Sample">CHAPTER SEVENTEEN</span></p>
<p class="cct" id="toc-19"><span href="#/chapter19#p0153-01-0" title="Link target outside of Sample">CHAPTER EIGHTEEN</span></p>
<p class="cct" id="toc-20"><span href="#/chapter20#p0159-01-0" title="Link target outside of Sample">CHAPTER NINETEEN</span></p>
<p class="cct" id="toc-21"><span href="#/chapter21#p0163-01-0" title="Link target outside of Sample">CHAPTER TWENTY</span></p>
<p class="cct" id="toc-22"><span href="#/chapter22#p0173-01-0" title="Link target outside of Sample">CHAPTER TWENTY-ONE</span></p>
<p class="cct" id="toc-23"><span href="#/chapter23#p0177-01-0" title="Link target outside of Sample">CHAPTER TWENTY-TWO</span></p>
<p class="cct" id="toc-24"><span href="#/chapter24#p0181-01-0" title="Link target outside of Sample">EPILOGUE</span></p>
<p class="cct" id="toc-25"><span href="#/chapter25#p0183-01-0" title="Link target outside of Sample">READING GROUP GUIDE</span></p>
<p class="cct" id="toc-26"><span href="#/chapter26#p0187-01-0" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
<p class="cct" id="toc-27"><span href="#/chapter27#p0189-01-0" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?def5dd58